import React from "react";
import { DiscountInfoStripWrapper } from "./assets/style";


export const DiscountInfoStrip = ({ discountText }: {discountText:string}) => (
  <DiscountInfoStripWrapper className={"layout center-center discount-info-strip"} dangerouslySetInnerHTML={{ __html: discountText }}>
  </DiscountInfoStripWrapper>
);
